import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, FormHelperText, Grid, Stack, TextField, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../../../libs/Context';
import useYoutubeURL from '../../../../../../../../libs/CustomHooks/useYoutubeURL';
import { createFeedContext } from '../..';

import { toast } from 'react-toastify';

const UrlPopup = (props) =>
{
	const { handleClose, open, type } = props;
	const { language } = useContext(LanguageContext);
	const [ pasteUrl, setPasteUrl ] = useState<string>('');
	const [ error, setError ] = useState<any>({});
	const { createFeed, setCreateFeed } = useContext(createFeedContext);
	const youtubeObj = {
		pasteUrl,
		setPasteUrl,
		edit           : undefined,
		setYouTubeData : setCreateFeed,
		setData        : undefined,
		youTubeData    : createFeed,
		setError,
		type           : 'newsfeed',
		handleClose
	};
	const { handleUrl, handleUploadUrl } = useYoutubeURL(youtubeObj);

	const isValidUrl = (url) =>
	{
		const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

		return urlPattern.test(url);
	};

	const handleDone = () =>
	{
		if (isValidUrl(pasteUrl))
		{
			// type === 'link' ? setCreateFeed((prev) => ({ ...prev, link: pasteUrl })) : handleUploadUrl();
			type === 'link'
				? setCreateFeed((prev) => ({ ...prev,
					media : [ ...(prev?.media ?? []), {
						url   : pasteUrl,
						type  : 'link',
						key   : pasteUrl,
						name  : '',
						title : '',
						size  : 0
					} ] }))
				: handleUploadUrl();

			handleClose();
		}
		else
		{
			toast.error(language.pleaseEnterValidUrl, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
			<DialogContent>
				<Grid container direction={'column'}>
					<Typography fontSize={'var(--pixel22)'} fontWeight='var(--font500)' pb='var(--pixel16)'>
						{type === 'link' ? language.pasteYourLink : language?.enterurl}
					</Typography>
					<TextField
						id='outlined-basic'
						value={pasteUrl || ''}
						onChange={handleUrl}
						fullWidth
						placeholder={language.addUrl}
						variant='outlined'
						autoFocus
						onKeyDown={(e) =>
						{
							if (e.key === 'Enter' && isValidUrl(pasteUrl))
							{
								handleDone();
							}
						}}
					/>
					{error?.url && (
						<FormHelperText
							id='txtFirstName-error'
							className='errorTxt'
						>
							{error.url}
						</FormHelperText>
					)}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Stack direction={'row'} spacing={2} px='var(--pixel16)' pb='var(--pixel8)'>
					<Button variant='outlined' onClick={handleClose}>
						{language?.cancel}
					</Button>
					<Button
						variant='contained'
						onClick={handleDone}
						sx={{
							color         : 'var(--whiteColor)',
							opacity       : pasteUrl ? '1' : '0.5',
							pointerEvents : pasteUrl ? 'auto' : 'none'
						}}
					>
						{language?.done}
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default UrlPopup;
